import type { Evidence, ProcessUploadResponse } from 'api';

import type { NonNullableField } from '../types';

export enum PhotoRejectionReason {
  TOO_CLOSE = 'Bale too close',
  TOO_FAR = 'Bale too far',
  BAD_FRAME = 'Poor camera angle',
  BAD_QUALITY = 'Low lighting/blurry',
  LOW_RESOLUTION = 'Low image resolution',
  LOW_QUALITY = 'System error',
  INVALID_FORMAT = 'Invalid file format',
  EMPTY_FILE = 'The file is empty',
  DUPLICATE = 'Duplicate photo',
  BAD_ASPECT_RATIO = 'Poor aspect ratio',
  TREERING = 'Squashed baleface',
  OVER_EXPOSED = 'Image is too bright',
  UNDER_EXPOSED = 'Image is too dark',
}

export type AnalysisStatus = 'accepted' | 'rejected-material' | 'rejected-photo' | 'retry';

export type Bale = {
  id: string;
  photo: File;
  analysis?: ProcessUploadResponse;
  isLoading?: boolean;
  analysisStatus?: AnalysisStatus;
  loadingStatus?: 'loaded' | 'not-loaded';
  uploadProgress?: number;
  photoRejectedReason?: PhotoRejectionReason;
  evidenceId?: number;
};

export type BalePhotoEvidence = Evidence & {
  analysisStatus: AnalysisStatus;
  photoRejectedReason?: PhotoRejectionReason;
  loadingStatus?: 'loaded' | 'not-loaded';
};

export type EvidenceWithModelResults = NonNullableField<Evidence, 'model_results'>;

export enum BaleModels {
  PET = 'pet',
  ALU = 'alu',
  BRIQUETTE = 'briquette',
}
export const baleModels = Object.values(BaleModels);
export const isBaleModel = (model: string): model is BaleModels => {
  return baleModels.includes(model as BaleModels);
};
